<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <!-- <v-card> -->
        <!-- <v-card-title class="elevation-0">
          <span class="itemHeading">Organisations List</span>
          <v-spacer></v-spacer>
        </v-card-title> -->
        <v-layout wrap justify-start>
          <v-flex xs12 pa-4>
            <v-layout wrap>
              <v-flex align-self-center text-left>
                <span style="font-family: poppinssemibold">ORGANISATIONS</span>
              </v-flex>
              <v-flex xl3 lg3 md3 sm3 xs12 pb-2 pl-6 text-right>
                <v-dialog
                  :retain-focus="false"
                  v-model="dialog"
                  persistent
                  max-width="50%"
                  :key="dialog"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      style="font-family: poppinsmedium"
                      block
                      small
                      dark
                      class="rounded-xl text-none"
                      color="#5F4B8BFF"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>mdi-pencil-plus-outline</v-icon>&nbsp; Add
                      Organisation
                    </v-btn>
                  </template>
                  <v-card>
                    <v-form v-model="addcat" ref="addcat">
                      <!-- <v-card-title>
                       
                      </v-card-title> -->
                      <!-- <v-card-text> -->
                      <v-layout wrap>
                        <v-flex xs12 style="background-color: #5f4b8bff">
                          <span
                            style="
                              color: #ffffff;
                              font-size: 20px;
                              font-family: poppinsbold;
                              padding: 2px;
                            "
                            class="RB"
                            >ADD ORGANISATION</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout wrap pa-12 justify-center fill-height>
                        <v-flex xs12 align-self-center text-left>
                          <span>Organisation Name*</span>
                          <br />
                          <v-text-field
                            v-model="name"
                            placeholder="Organisation Name"
                            :rules="[rules.required]"
                            required
                            outlined
                            hide-details
                            dense
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 align-self-center text-left pt-3>
                          <span>Organisation Type*</span>
                          <br />
                          <v-autocomplete
                            v-model="organisationType"
                            :items="organisationsTypes"
                            placeholder="Organisation Type"
                            :rules="[rules.required]"
                            item-text="type"
                            item-value="_id"
                            required
                            outlined
                            hide-details
                            dense
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 align-self-center text-left pt-3>
                          <span>E-mail*</span>
                          <br />
                          <v-text-field
                            v-model="Email"
                            :rules="[rules.email]"
                            dense
                            placeholder="E-mail"
                            required
                            outlined
                            hide-details
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <!-- </v-card-text> -->
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#ED2B33FF" text @click="dialogclose()">
                          Close
                        </v-btn>
                        <v-btn
                          color="#0063B2FF"
                          text
                          :disabled="!addcat"
                          @click="addOrganisation()"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-progress-linear
              :color="appColor"
              rounded
              value="100"
              height="2px"
            ></v-progress-linear>
          </v-flex>
          <v-flex
            xs12
            md6
            sm6
            lg4
            xl3
            align-self-center
            v-for="(item, i) in organisations"
            :key="i"
            fill-height
            pa-2
          >
            <v-card
              tile
              elevation="2"
              outlined
              style="
                border-radius: 0px 0px 20px !important;
                border-bottom: 5px solid #5f4b8bff;
              "
            >
              <v-layout wrap justify-center py-4>
                <v-flex
                  xs12
                  align-self-start
                  text-left
                  pa-3
                  style="cursor: pointer"
                  @click="$router.push('/DetailedViewPage?id=' + item._id)"
                >
                  <span style="font-family: poppinsmedium">
                    <v-icon x-small>mdi-domain</v-icon> &nbsp;{{
                      item.name
                    }}</span
                  >
                  <br />
                  <span style="font-size: 12px; font-family: poppinsregular">
                    <v-icon x-small v-if="item.email">mdi-email</v-icon>&nbsp;{{
                      item.email
                    }}</span
                  >
                  <br />
                  <span
                    style="font-size: 12px; font-family: poppinsregular"
                    v-if="item.type"
                  >
                    <v-icon x-small>mdi-pen</v-icon>&nbsp;{{
                      item.type.type
                    }}</span
                  >
                </v-flex>
                <!-- </v-layout>
                <v-layout wrap justify-center py-4> -->
                <v-flex xs12 sm4 pa-2>
                  <v-btn
                    color="#0063B2FF"
                    style="font-family: poppinsmedium"
                    x-small
                    block
                    tile
                    dark
                    @click="editcat(item)"
                    >Edit</v-btn
                  >
                </v-flex>
                <v-flex xs12 sm4 pa-2>
                  <v-dialog persistent v-model="item.delete" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        style="font-family: poppinsmedium"
                        class="mr-2"
                        dark
                        block
                        tile
                        v-on="on"
                        v-bind="attrs"
                        color="#ED2B33FF"
                      >
                        Delete
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title
                        >Are you sure you want to delete this
                        Organisation?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="#ED2B33FF"
                          text
                          @click="item.delete = false"
                          >Cancel</v-btn
                        >
                        <v-btn color="#0063B2FF" text @click="deleteItem(item)"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-dialog persistent v-model="editdialog" max-width="50%">
            <v-card tile>
              <!-- <v-card-title>
                <span class="headline">Edit Organisation</span>
              </v-card-title> -->
              <!-- <v-card-text> -->
              <v-layout wrap>
                <v-flex xs12 style="background-color: #5f4b8bff">
                  <span
                    style="
                      color: #ffffff;
                      font-size: 20px;
                      font-family: poppinsbold;
                      padding: 2px;
                    "
                    class="RB"
                    >EDIT ORGANISATION</span
                  >
                </v-flex>
              </v-layout>
              <v-layout wrap pa-12>
                <v-flex xs12 text-left>
                  Organisation Name*
                  <br />
                  <v-text-field
                    v-model="editingitem.name"
                    placeholder="Organisation Name"
                    :rules="[rules.required]"
                    outlined
                    dense
                    required
                    hide-details
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 align-self-center text-left pt-3>
                  <span>Organisation Type*</span>
                  <br />
                  <v-autocomplete
                    v-model="editingitem.type"
                    :items="organisationsTypes"
                    placeholder="Organisation Type"
                    :rules="[rules.required]"
                    item-text="type"
                    item-value="_id"
                    required
                    outlined
                    hide-details
                    dense
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 align-self-center text-left pt-3>
                  <span>E-mail*</span>
                  <br />
                  <v-text-field
                    v-model="editingitem.email"
                    :rules="[rules.email]"
                    dense
                    placeholder="E-mail"
                    required
                    outlined
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <!-- </v-card-text> -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#ED2B33FF" text @click="getdData"> Close </v-btn>
                <v-btn
                  v-if="editingitem.name"
                  color="#0063B2FF"
                  text
                  @click="edit(editingitem._id)"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// import ImageComp from  "@/components/Common/singleImage";
import axios from "axios";
export default {
  data() {
    return {
      Email: null,
      employee: null,
      organisationsTypes: [],
      organisationType: null,
      employeeList: [],
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      dialog: false,
      editdialog: false,
      editingitem: [],
      name: "",
      pageCount: 1,
      appLoading: false,
      editedIndex: -1,
      currentPage: 1,
      g: false,
      perPage: 4,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      itemname: "",
      addcat: false,
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      organisations: [],
      data: [],
      coverImageFile: null,
      selectedFiles: [],
      image: null,
      coverImageArray: [],
      formDataCover: new FormData(),
      flagg: true,
    };
  },
  components: {
    // ImageComp,
  },
  mounted() {
    this.getData();
    // this.employeeLists();
    this.getOrg();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    getdData() {
      this.editdialog = false;
      this.getData();
    },

    deleteItem(cat) {
      var data = {};
      data["id"] = cat._id;
      axios({
        url: "/organization/remove",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;

            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/organization/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.organisations = response.data.data;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.name = null;
      this.dialog = false;
    },

    addOrganisation() {
      var data = {};
      data["name"] = this.name;
      data["type"] = this.organisationType;
      data["email"] = this.Email;
      axios({
        url: "/add/organization",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Added Sucessfully";
            this.showsnackbar = true;
            this.name = null;
            this.dialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editcat(item) {
      this.editingitem = item;
      this.editingitem.type = this.editingitem.type._id;
      this.editdialog = true;
    },
    edit() {
      var data = {};
      data["id"] = this.editingitem._id;
      data["name"] = this.editingitem.name;
      data["type"] = this.editingitem.type;
      data["email"] = this.editingitem.email;

      axios({
        url: "/organization/edit",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.editdialog = false;

          this.appLoading = false;
          if (response.data.status) {
            // if (this.coverImageFile) {
            //   this.uploadCoverImages(this.editingitem._id);
            // }
            this.msg = "Edited Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    employeeLists() {
      this.appLoading = true;
      axios({
        url: "/admin/view/employeelist",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.employeeList = response.data.data;
          } else {
            this.showsnackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getOrg() {
      this.appLoading = true;
      axios({
        url: "/organization/type/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.organisationsTypes = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
